import { createApp } from "vue";
import loginPage from './loginPage.vue';
import jsLoader from './jsLoader.vue';

createApp(loginPage).mount("#app");
createApp(jsLoader).mount("#jsLoader");
